<div class="scenario-card">
  <div class="scenario-header">
    <span class="plate sm">{{ registration }}</span>
    <span class="scenario-meta">{{ meta }}</span>
  </div>
  <p class="scenario-body">{{ body }}</p>
  <div class="scenario-trail">
    <ng-container *ngFor="let step of trail; let last = last">
      <span [class.scenario-trail-final]="step.final">{{ step.text }}</span>
      <span class="scenario-arrow" *ngIf="!last">&rarr;</span>
    </ng-container>
  </div>
</div>
